import { WithSearch } from '@elastic/react-search-ui'
import React, { ReactNode, useEffect, useRef, useState } from 'react'

type AutoStateRenderArgs = {
  searchTerm: string
  isLoading: boolean
}

interface SearchAutocompleteWrapperProps {
  minChars?: number
  children: (args: AutoStateRenderArgs) => ReactNode
}

interface InnerProps {
  searchTerm: string
  autocompletedResultsRequestId?: string
  autocompletedSuggestionsRequestId?: string
}

export const SearchAutocompleteWrapper = ({
  minChars = 3,
  children,
}: SearchAutocompleteWrapperProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const lastTermRef = useRef<string>('')
  const lastResIdRef = useRef<string | null>(null)
  const lastSugIdRef = useRef<string | null>(null)

  const Inner = ({
    searchTerm,
    autocompletedResultsRequestId,
    autocompletedSuggestionsRequestId,
  }: InnerProps) => {
    useEffect(() => {
      if (searchTerm !== lastTermRef.current) {
        lastTermRef.current = searchTerm
        setIsLoading(searchTerm.length >= minChars)
      }
    }, [searchTerm, minChars])

    useEffect(() => {
      if (
        autocompletedResultsRequestId &&
        autocompletedResultsRequestId !== lastResIdRef.current
      ) {
        lastResIdRef.current = autocompletedResultsRequestId
        setIsLoading(false)
      }
    }, [autocompletedResultsRequestId])

    useEffect(() => {
      if (
        autocompletedSuggestionsRequestId &&
        autocompletedSuggestionsRequestId !== lastSugIdRef.current
      ) {
        lastSugIdRef.current = autocompletedSuggestionsRequestId
        setIsLoading(false)
      }
    }, [autocompletedSuggestionsRequestId])

    return <>{children({ searchTerm, isLoading })}</>
  }

  return (
    <WithSearch
      mapContextToProps={({
        searchTerm,
        autocompletedResultsRequestId,
        autocompletedSuggestionsRequestId,
      }) => ({
        searchTerm: searchTerm ?? '',
        autocompletedResultsRequestId,
        autocompletedSuggestionsRequestId,
      })}
    >
      {ctx => (
        <Inner
          searchTerm={ctx.searchTerm ?? ''}
          autocompletedResultsRequestId={ctx.autocompletedResultsRequestId}
          autocompletedSuggestionsRequestId={
            ctx.autocompletedSuggestionsRequestId
          }
        />
      )}
    </WithSearch>
  )
}
